/** @jsx jsx */
import { Button, Elevation, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { css, jsx } from '@emotion/core';
import { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import PersonStatusSelect from '../../../components/PersonStatusSelect';
import { UserStatus } from '../../../generated/graphql';
import useQueryParams from '../../../hooks/useQueryParams';
import CompanionCreateOverlay from '../components/CompanionCreateOverlay';
import CompanionList from '../components/CompanionList';
import config from '../../../helpers/config';
import { openTab } from '../../../helpers/utils';

const CompanionListPage = () => {
  const queryParams = useQueryParams();
  const history = useHistory();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const status = (queryParams.get('status') as UserStatus) || UserStatus.Active;

  const changeStatus = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newStatus = event.currentTarget.value;
    queryParams.set('status', newStatus);
    history.push({ search: `?${queryParams.toString()}` });
  };

  const onCreated = (modelId: string) => {
    AppToaster.success('Begleiter hinzugefügt!');
    history.push(`/companions/${modelId}`);
  };

  return (
    <ContentCard elevation={Elevation.TWO} css={styles.list}>
      <CompanionCreateOverlay
        isOpen={isCreateDialogOpen}
        onSuccess={onCreated}
        onClose={() => setIsCreateDialogOpen(false)}
      />
      <ContentCardHeader
        leftElement={<PersonStatusSelect value={status} onChange={changeStatus} />}
        rightElement={
          <Fragment>
            <Button
              text="Hinzufügen"
              icon={IconNames.ADD}
              intent={Intent.PRIMARY}
              css={styles.headerButton}
              onClick={() => setIsCreateDialogOpen(true)}
            />
            <Button
              text="Exportieren"
              icon={IconNames.EXPORT}
              css={styles.headerButton}
              onClick={() => openTab(`${config.baseUrl}/downloads/companions`)}
            />
          </Fragment>
        }
      />
      <CompanionList />
    </ContentCard>
  );
};

export default CompanionListPage;

const styles = {
  headerButton: css`
    margin-left: 10px;
  `,
  list: css`
    margin-bottom: 20px;
  `,
};
